import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'

export const Container = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
  background: unset;
  padding-inline: ${pxToRem(16)} ${pxToRem(8)};
  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    inset: 0 0 0 0;
    background: ${({ theme }) => theme.colors.white};
    transition: transform 0.3s ease-in-out;
    transform: translateY(-100%);
  }
  &:hover::before,
  &[aria-expanded='true']::before {
    transform: translateY(-0%);
  }
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(40)} ${pxToRem(32)};
  }
`

export const Label = styled.span`
  ${({ theme }) => theme.textStyles.d1440_button}
  color: ${({ theme }) => theme.colors.black};
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  transition: transform 0.3s ease-in-out;
  ${Container}:hover & {
    text-decoration: underline;
  }
  & span {
    display: block;
    grid-row: 1;
    grid-column: 1;
  }
  & span[hidden] {
    opacity: 0;
  }
  ${Container}[aria-expanded='true'] & {
    transform: translateX(${pxToRem(-8)});
  }
`
export const Icon = styled.i<{ $open?: boolean }>`
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  width: ${pxToRem(48)};
  aspect-ratio: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(5)};
  & i {
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.colors.black};
  }
  & i:nth-child(1) {
    transform-origin: calc(100% / 3) 0;
    transition: transform 0.3s ease-in-out;
  }
  & i:nth-child(2) {
    transition: transform 0.2s ease-in-out;
  }
  & i:nth-child(3) {
    transform-origin: calc(100% / 3) 0;
    transition: transform 0.3s ease-in-out;
  }
  ${Container}[aria-expanded='true'] & {
    & i:nth-child(1) {
      transform: rotate(45deg);
    }
    & i:nth-child(2) {
      transform: scaleX(0);
    }
    & i:nth-child(3) {
      transform: rotate(-45deg);
    }
  }
`
